import React, { useEffect, useMemo, useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import { LocalPrintshopOutlined } from "@material-ui/icons";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { HeaderModal } from "../styles/Emissao";
import TableDefault from "../../../../components/grid/TableDefault";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";

import MaskService from "../../../../utils/mask/maskService";
import useNfeController from "../controllers/NfeController";

const ModalDuplicataMercantil = ({
  openModal,
  setOpenModal,
  nfeRow,
  setNfeRow,
}) => {
  const {
    handleGetDuplicateData,
    handleOpenDownloadBilletFile,
    handleDownloadMercantileDuplicate,
  } = useNfeController();

  const [duplicateData, setDuplicateData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const disableDuplicateButton = useMemo(
    () =>
      !selectedItems.length ||
      !!selectedItems.find((item) => !item.is_valid_duplicate),
    [selectedItems]
  );

  const handleClose = () => {
    setNfeRow({});
    setOpenModal(false);
  };

  const mercantilColumns = [
    {
      label: "Ações",
      format: (value) => {
        let itemActions = [
          {
            icon: <LocalPrintshopOutlined />,
            name: "Imprimir Boleto",
            action: () => {
              handleOpenDownloadBilletFile({
                crId: [value.id],
              });
            },
            disabled: !value?.have_bank_billet || !value.is_valid_duplicate,
          },
        ];

        return <SpeedDialErp actions={itemActions} />;
      },
      align: "center",
    },
    {
      id: "document_number",
      label: "Número do Documento",
    },
    {
      id: "document_value",
      label: "Valor",
      format: (value) =>
        value?.document_value
          ? Number(value.document_value).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          : "-",
    },
    {
      id: "due_date",
      label: "Data de Vencimento",
      format: (value) =>
        value?.due_date ? MaskService.dateYmdToDmy(value.due_date) : "-",
    },
  ];

  useEffect(() => {
    handleGetDuplicateData({ setDuplicateData, nfeId: nfeRow?.id });
  }, [handleGetDuplicateData, nfeRow]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={openModal}
      onClose={handleClose}
      aria-labelledby="dialog-duplicata-mercantil"
    >
      <HeaderModal>
        <DialogTitle id="dialog-title-duplicata-mercantil">
          <Chip
            label={`Duplicatas/Boleto referente a nota fiscal número ${
              nfeRow?.numero || "-"
            }`}
            bgcolor="primary"
            textcolor="white"
          />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <TableDefault
          values={duplicateData}
          columns={mercantilColumns}
          selectable
          selected={selectedItems}
          setSelected={setSelectedItems}
          selectedByRow={false}
          allChecked
        />
      </DialogContent>
      <DialogActions>
        <Btn
          label="Duplicata"
          onClick={() => {
            handleDownloadMercantileDuplicate({
              nfeId: nfeRow?.id,
              selectedItems,
            });
          }}
          disabled={disableDuplicateButton}
        />
        <Btn
          bgcolor="tertiary"
          hovercolor="blue"
          onClick={handleClose}
          label="cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalDuplicataMercantil;
